export const normalizeSalesOrderEditStatus = ({ salesOrderStatus, projectSoStatus } = {}) => {
  const raw = String(projectSoStatus || salesOrderStatus || "").trim().toLowerCase();
  if (!raw) return "unknown";

  if (
    raw === "1" ||
    raw === "estimate" ||
    raw.includes("estimate draft")
  ) {
    return "estimate-draft";
  }

  if (
    raw === "1_sent" ||
    raw.includes("estimate sent")
  ) {
    return "estimate-sent";
  }

  if (raw === "8" || raw.includes("ready to be invoiced")) return "ready-to-be-invoiced";
  if (raw === "9" || raw === "invoiced" || raw.includes("invoiced")) return "invoiced";
  if (raw === "7" || raw.includes("shipped")) return "shipped";
  if (raw === "6" || raw.includes("in production")) return "in-production";
  if (raw === "4" || raw.includes("change requested")) return "client-change-requested";

  if (
    raw === "3" ||
    raw.includes("client approved") ||
    raw.includes("sales order ready") ||
    raw.includes("customer signed")
  ) {
    return "client-approved";
  }

  if (
    raw === "2_sent" ||
    raw.includes("agreement sent") ||
    raw.includes("sales order sent")
  ) {
    return "agreement-sent";
  }

  if (
    raw === "2" ||
    raw.includes("agreement pending") ||
    raw.includes("sales order - agreement") ||
    raw === "agreement"
  ) {
    return "agreement";
  }

  return "unknown";
};

export const getSalesOrderEditStatusMessage = (editStatus) => {
  if (editStatus === "invoiced") {
    return "This sales order is invoiced and locked.";
  }
  if (editStatus === "ready-to-be-invoiced") {
    return "This sales order is ready to be invoiced. Editing is restricted at this stage, but the order has not yet been invoiced.";
  }
  if (editStatus === "estimate-sent" || editStatus === "agreement-sent") {
    const documentLabel = editStatus === "estimate-sent" ? "Estimate" : "Agreement";
    return `${documentLabel} has been sent. Address and contact fields remain editable; administrators can also update terms and default tax.`;
  }
  return "Changes are saved when you click Save. Address/contact selections auto-save.";
};
